<template>
  <div class="cover">
    <div class="content">
      <h1 class="center">{{ datas.articleTitle }}</h1>
      <p class="justify-end">
        {{ datas.createTime }}
      </p>
      <div v-html="datas.articleContent"></div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail } from "@/api/api";
export default {
  name: "messageDetail",
  components: {},
  data() {
    return {
      datas: {
        articleTitle: "sadfsdfsdf",
        articleContent: "<h1>sfdfdsf</h1>",

        createTime: "2000-20-20"
      }
    };
  },
  created() {},
  mounted() {
    getArticleDetail(this.$route.query.id).then(res => {
      this.datas = res.data || {};
    });
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/view/messageDetail.vue